<template>
  <v-card 
  v-if="false"
  hover
  class="mrow">
    <v-card-text>
      <img src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="60px">
      <div>
        {{ delivery.id }}
      </div>
      <div class="caption text--text text--darken-1">
        Date
        {{ delivery.date }}
      </div>
    </v-card-text>
  </v-card>

  <!-- MOBILE CARD -->
  <div 
  v-else
  v-ripple
  :class="['c-flex-c mrow']">
    
    <div class="c-flex-r1 pt-1 pb-1">

      <div class="c-flex-r1 pl-3 pr-3">

        <div>
          <img src="@/assets/img/illustrations/package.png" alt="cardboard box" width="32px">
        </div>

        <div class="c-flex-r1 ml-2 align-start">

          <div class="c-flex-c1">
            <div>
              <c-metric-selector
              :realValue="totalCount"
              :inventoryItemID="inventoryItemId" 
              :alwaysScale="true"
              :key="inventoryItemId"
              labelMode
              ></c-metric-selector>
            </div>
            <div 
            class="caption text--text text--darken-1 c-flex-r1">
              <div class="caption text--text text--darken-1">
                {{ dateFromNow }}
              </div>
              <v-spacer></v-spacer>
              <div class="caption">
                id: {{ delivery.id }}
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <div class="local-border-bottom"></div>

  </div>
</template>

<script>
export default {
  props: ['id', 'inventoryItemId'],
  data () {
    return {
      // 5
    }
  },
  computed: {
    delivery () {
      return this.$store.state.db.deliveries.deliveries[this.id]
    },
    dateFromNow () {
      if (this.$moment.utc(this.delivery.date).isValid()) {
        return this.$moment.utc(this.delivery.date).fromNow()
      }
      return ''
    },
    totalCount () {
      var items = this.$store.getters['db/deliveryItems/getDeliveryItems'](parseInt(this.id))
      return items.reduce((a, i) => {
        if (i.inventory_item_id === this.inventoryItemId) {
          a += i.quantity
        }
        return a
      }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  position: relative;

  &:hover {
    background: #fafbfc;
  }
}
</style>
